import PublicExaminationInstruction from './PublicExaminationInstruction';

export default PublicExaminationInstruction;
